import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import ManagementSubscriptionPage from "../app/(general-header)/management-subscription/page";

const root = createRoot(document.getElementById("management-subscription-page") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <ManagementSubscriptionPage />
    </StoreProvider>
  </React.StrictMode>
);
